// extracted by mini-css-extract-plugin
export default {"container":"checkbox_container__jE+uD","checkbox":"checkbox_checkbox__jsv7v","checkboxMark":"checkbox_checkboxMark__UP2Mg"};